import http from '@/plugs/httpServer';
import { serverName } from '@wj/common';
let feather_campus= "feather-campus"


// 获取面试管理中tab标签数据
export function getTabList(data: object) {
    return http({
        method: 'GET',
        url: `${feather_campus}/deliver/interviewManage`,
        params: data,
    })
}
// 获取面试管理中tab标签数据
export function getTabList23(data: object) {
    return http({
        method: 'GET',
        url: `${feather_campus}/deliver/universityLabel`,
        params: data,
    })
}
// 获取面试官
export function getInterviewerList(data: object) {
    return http({
        method: 'GET',
        url: `${feather_campus}/user/getUserByDepartments`,
        params: data,
    })
}
// 面试结果录入
export function evaluateDelivers(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/evaluateDelivers`,
        data: data,
    })
}
// 面试结果
export function getDelState(data: object) {
    return http({
        method: 'GET',
        url: `${feather_campus}/deliver/getDelState`,
        params: data,
    })
}
// 通知状态
export function getNoticeStateList(data: object) {
    return http({
        method: 'GET',
        url: `${feather_campus}/deliver/getNoticeState`,
        params: data,
    })
}

// 岗位列表
export function getPosition(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/job/getAllJobs`,
        data: data,
    })
}
// 面试结果通知
export function sendResults(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/sendResults`,
        data: data,
    })
}
// 查询tab标签下的列表数据
export function getResumeList(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/pageDeliver`,
        data: data,
    })
}
// 查询tab标签下的列表数据
export function sendInterviewNotice(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/sendInterview`,
        data: data,
    })
}

// 单列表查询
export function getByPage(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/pageDeliver`,
        data: data,
    })
}
